/* @ngInject */
export const unhandledRejectionConfig = ($qProvider) => {
	$qProvider.errorOnUnhandledRejections(true);
};
